import React, { useEffect, useState } from 'react';
import './CpPage.css';

function CpPage() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    // Load Google Fonts
    const fontLink = document.createElement('link');
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap';
    fontLink.rel = 'stylesheet';
    document.head.appendChild(fontLink);

    // Load Font Awesome
    const faLink = document.createElement('link');
    faLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css';
    faLink.rel = 'stylesheet';
    document.head.appendChild(faLink);

    // Scroll to top
    window.scrollTo(0, 0);

    // Navbar scroll effect
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);

    // Fade in animation
    const fadeElements = document.querySelectorAll('.cp-page .fade-in');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    fadeElements.forEach(element => observer.observe(element));

    return () => {
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setMenuOpen(false);
    }
  };

  return (
    <div className="cp-page">
      {/* Navigation */}
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <a href="#cp-home" className="logo" onClick={(e) => handleNavClick(e, '#cp-home')}>
          <img
            src="https://vahaan-buy-and-sell-category-images.s3.ap-south-1.amazonaws.com/VahaanBazar_Image.png"
            alt="Vahaan Bazar Logo"
            className="logo-img"
          />
        </a>
        <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <li><a href="#cp-home" onClick={(e) => handleNavClick(e, '#cp-home')}>Home</a></li>
          <li><a href="#cp-about" onClick={(e) => handleNavClick(e, '#cp-about')}>About</a></li>
          <li><a href="#cp-modules" onClick={(e) => handleNavClick(e, '#cp-modules')}>Modules</a></li>
          <li><a href="#cp-why-us" onClick={(e) => handleNavClick(e, '#cp-why-us')}>Why Us</a></li>
          <li><a href="#cp-contact" onClick={(e) => handleNavClick(e, '#cp-contact')}>Contact</a></li>
          <li><a href="https://play.google.com/store/apps/details?id=com.vahaanbazar.app" className="nav-cta" target="_blank" rel="noopener noreferrer"><i className="fas fa-download"></i> Download App</a></li>
        </ul>
        <button className="mobile-menu" onClick={toggleMenu}>
          <i className="fas fa-bars"></i>
        </button>
      </nav>

      {/* Hero Section */}
      <section className="hero" id="cp-home">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-badge">
              <i className="fas fa-mobile-alt"></i> Now Available on Mobile
            </div>
            <h1>India's Fastest Growing <span>Used vehicles</span> Marketplace</h1>
            <p className="hero-tagline">Hamara Gaadi Bazar....</p>
            <p className="hero-description">
              Buy, Sell, Auction, Finance, Insure & Service your vehicles - all in one powerful app.
              Trusted by fleet owners, dealers, and individuals across India.
            </p>
            <div className="hero-features">
              <div className="hero-feature">
                <i className="fas fa-check-circle"></i>
                <span>Verified Listings</span>
              </div>
              <div className="hero-feature">
                <i className="fas fa-check-circle"></i>
                <span>Live Auctions</span>
              </div>
              <div className="hero-feature">
                <i className="fas fa-check-circle"></i>
                <span>24/7 Support</span>
              </div>
            </div>
            <div className="hero-cta">
              <a href="#cp-modules" className="btn btn-primary" onClick={(e) => handleNavClick(e, '#cp-modules')}>
                <i className="fas fa-compass"></i> Explore Modules
              </a>
              <div className="app-badges">
                <a href="https://play.google.com/store/apps/details?id=com.vahaanbazar.app" className="app-badge-img" target="_blank" rel="noopener noreferrer">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" />
                </a>
                <a href="https://apps.apple.com/in/app/vahaanbazar/id6753955870" className="app-badge-img" target="_blank" rel="noopener noreferrer">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on the App Store" />
                </a>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-phone">
              <div className="phone-frame">
                <div className="phone-screen">
                  <div className="phone-header">
                    <img src="https://vahaan-buy-and-sell-category-images.s3.ap-south-1.amazonaws.com/VahaanBazar_Image.png" alt="VahaanBazar" className="phone-logo" />
                  </div>
                  <div className="phone-content">
                    <div className="phone-module"><i className="fas fa-gavel"></i> Auctions</div>
                    <div className="phone-module"><i className="fas fa-exchange-alt"></i> Buy & Sell</div>
                    <div className="phone-module"><i className="fas fa-shield-alt"></i> Insurance</div>
                    <div className="phone-module"><i className="fas fa-search"></i> Inspection</div>
                    <div className="phone-module"><i className="fas fa-tools"></i> Service</div>
                    <div className="phone-module"><i className="fas fa-cogs"></i> Spares</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hero-stats">
              <div className="hero-stat">
                <span className="stat-number">10K+</span>
                <span className="stat-label">Active Users</span>
              </div>
              <div className="hero-stat">
                <span className="stat-number">6</span>
                <span className="stat-label">Modules</span>
              </div>
              <div className="hero-stat">
                <span className="stat-number">Pan-India</span>
                <span className="stat-label">Coverage</span>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-categories">
          <span>TRUCKS</span>
          <span className="separator">|</span>
          <span>CONSTRUCTION MACHINES</span>
          <span className="separator">|</span>
          <span>CARS</span>
          {/* <span className="separator">|</span>
          <span>Fleet Management </span> */}
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro" id="cp-about" style={{
        background: `linear-gradient(rgba(255, 255, 255, 0.88), rgba(255, 255, 255, 0.88)), url('/images/cp/new_image.png') center/cover no-repeat fixed`
      }}>
        <div className="section-header">
          <div className="section-badge">ABOUT US</div>
          <h2 className="section-title">Introduction</h2>
        </div>
        <div className="intro-grid">
          <div className="intro-content fade-in">
            <p>VahaanBazar is India's first comprehensive digital marketplace for used Commercial Vehicles, Construction Equipment, and all vehicle-related services.</p>
            <p>Our platform allows buyers and sellers to interact, negotiate, and close transactions in a timely, transparent, and cost-effective manner.</p>
            <p>Now available as a powerful Mobile App, VahaanBazar brings the entire used automobile ecosystem to your fingertips - from live auctions to doorstep inspections, from instant finance to roadside assistance.</p>
            <p><strong>Whether you're a Fleet Owner, Dealer, OEM, Transporter, or Individual Buyer - VahaanBazar serves everyone.</strong></p>
            <div className="intro-stats">
              <div className="stat-box">
                <i className="fas fa-compass"></i>
                <h4>6 Powerful Modules</h4>
              </div>
              <div className="stat-box">
                <i className="fas fa-map-marker-alt"></i>
                <h4>Pan-India Coverage</h4>
              </div>
              <div className="stat-box">
                <i className="fas fa-headset"></i>
                <h4>24/7 Support</h4>
              </div>
              <div className="stat-box">
                <i className="fas fa-check-circle"></i>
                <h4>Verified Listings</h4>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Who We Are Section */}
      <section className="who-we-are">
        <div className="section-header">
          <div className="section-badge">OUR IDENTITY</div>
          <h2 className="section-title">Who We Are & <span>What We Do</span></h2>
        </div>
        <div className="about-grid">
          <div className="about-card fade-in">
            <h3>Who We Are</h3>
            <p>Vahaan Bazar is India's trusted used automobile marketplace:</p>
            <ul>
              <li>Platform for businesses and individuals alike</li>
              <li>Buy, sell, auction, or service vehicles of all makes and models</li>
              <li>Community of Fleet Owners, Transporters & Construction Companies</li>
              <li>Dealers and Individual Buyers in one ecosystem</li>
              <li>Vibrant B2B & B2C marketplace</li>
              <li>Trusted by thousands across India</li>
            </ul>
          </div>
          <div className="about-card fade-in">
            <h3>What We Do</h3>
            <p>We provide an end-to-end used automobile solution through our mobile app with 6 integrated modules:</p>
            <ul>
              <li>Live Auctions with verified vehicles</li>
              <li>Buy & Sell marketplace with in-app inspections</li>
              <li>Insurance & Finance at competitive rates</li>
              <li>Professional Inspection & Valuation services</li>
              <li>Emergency Service Support with GPS-based assistance</li>
              <li>Spare Parts & Fleet Management Solutions</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Our Approach Section */}
      <section className="our-approach">
        <div className="intro-grid">
          <div className="intro-image fade-in">
            <img
              src="/images/cp/our_approach.png"
              alt="Our Approach - Mobile-first automobile marketplace"
              className="approach-image"
            />
          </div>
          <div className="intro-content fade-in">
            <div className="section-badge">OUR PHILOSOPHY</div>
            <h2>Our Approach</h2>
            <p>Customer satisfaction is at the core of everything we do.</p>
            <p>We understand that every stakeholder - whether a large fleet operator or an individual buyer - deserves a transparent, secure, and efficient experience.</p>
            <h4 style={{ marginTop: '20px', color: 'var(--primary)' }}>Our Mobile-First Approach Ensures:</h4>
            <ul className="feature-list">
              <li><strong>Instant Access</strong><span>Thousands of verified listings at your fingertips</span></li>
              <li><strong>Real-time Auctions</strong><span>Participate from anywhere, anytime</span></li>
              <li><strong>GPS-enabled Support</strong><span>Emergency assistance during breakdowns</span></li>
              <li><strong>Paperless Process</strong><span>Digital documentation and approvals</span></li>
              <li><strong>Direct Communication</strong><span>Connect buyers and sellers seamlessly</span></li>
            </ul>
          </div>
        </div>
      </section>

      {/* Management Section */}
      <section className="who-we-are">
        <div className="section-header">
          <div className="section-badge">LEADERSHIP</div>
          <h2 className="section-title">Our <span>Management</span></h2>
        </div>
        <div className="about-grid">
          <div className="about-card fade-in">
            <h3>Company Background</h3>
            <p>VahaanBazar is a Hyderabad-based startup backed by Automotive Industry Professionals.</p>
            <ul>
              <li>Leadership with 12+ years experience in After Market, Sales, Used Vehicle Market, and Customer Solutions</li>
              <li>Experience across various OEMs & Start-ups in managerial positions</li>
            </ul>
          </div>
          <div className="about-card fade-in">
            <h3>Our Strengths</h3>
            <ul>
              <li>In-house IT team with extensive expertise in automobile technology solutions</li>
              <li>Strong network of Mechanics, Dealers, NBFCs, and Insurance partners across India</li>
              <li>Committed to Service Excellence & Customer Satisfaction</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="intro" style={{
        background: `linear-gradient(rgba(255, 255, 255, 0.88), rgba(255, 255, 255, 0.88)), url('/images/cp/new_image.png') center/cover no-repeat fixed`
      }}>
        <div className="section-header">
          <div className="section-badge">OUR GOALS</div>
          <h2 className="section-title">Vision & <span>Mission</span></h2>
        </div>
        <div className="about-grid">
          <div className="about-card fade-in" style={{ background: 'linear-gradient(135deg, var(--primary), var(--primary-light))', color: 'white' }}>
            <h3 style={{ color: 'white' }}><i className="fas fa-eye"></i> Vision</h3>
            <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '18px' }}>To become India's largest used automotive digital ecosystem connecting automobile customers, OEMs, Dealers, Banks, Insurance Companies, Mechanics, and all stakeholders through one unified platform.</p>
          </div>
          <div className="about-card fade-in" style={{ background: 'linear-gradient(315deg, var(--primary), var(--primary-light))', color: 'white' }}>
            <h3 style={{ color: 'white' }}><i className="fas fa-rocket"></i> Mission</h3>
            <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '18px' }}>To revolutionize the used automobile marketplace by providing a seamless digital experience for buying, selling, financing, insuring, and servicing vehicles - making every transaction transparent, efficient, and rewarding.</p>
          </div>
        </div>
      </section>

      {/* App Overview / Modules Section */}
      <section className="modules" id="cp-modules">
        <div className="section-header">
          <div className="section-badge">OUR APP</div>
          <h2 className="section-title">VahaanBazar <span>Mobile App</span></h2>
          <p className="section-subtitle">Your Complete used Automobile Marketplace in One App - 6 Powerful Modules</p>
        </div>
        <div className="modules-grid">
          <div className="module-card fade-in" onClick={() => document.getElementById('cp-auctions').scrollIntoView({ behavior: 'smooth' })}>
            <div className="module-icon">
              <img src="/images/cp/auctions.png" alt="Auctions" className="module-img" />
            </div>
            <h3>Auctions</h3>
            <p className="tagline">Bid. Win. Drive.</p>
            <p>Participate in LIVE auctions for Commercial Vehicles and Construction Equipment from anywhere.</p>
          </div>
          <div className="module-card fade-in" onClick={() => document.getElementById('cp-buy-sell').scrollIntoView({ behavior: 'smooth' })}>
            <div className="module-icon">
              <img src="/images/cp/buysell.png" alt="Buy & Sell" className="module-img" />
            </div>
            <h3>Buy & Sell</h3>
            <p className="tagline">List. Connect. Deal.</p>
            <p>The largest marketplace for used Commercial Vehicles and Construction Equipment.</p>
          </div>
          <div className="module-card fade-in" onClick={() => document.getElementById('cp-insurance-finance').scrollIntoView({ behavior: 'smooth' })}>
            <div className="module-icon">
              <img src="/images/cp/insurancefinance.png" alt="Insurance & Finance" className="module-img" />
            </div>
            <h3>Insurance & Finance</h3>
            <p className="tagline">Protect. Fund. Grow.</p>
            <p>Get the best insurance coverage and financing options at attractive market rates.</p>
          </div>
          <div className="module-card fade-in" onClick={() => document.getElementById('cp-inspection').scrollIntoView({ behavior: 'smooth' })}>
            <div className="module-icon">
              <img src="/images/cp/inspectionvaluation.png" alt="Inspection & Valuation" className="module-img" />
            </div>
            <h3>Inspection & Valuation</h3>
            <p className="tagline">Inspect. Evaluate. Decide.</p>
            <p>Professional vehicle inspection and accurate valuation reports at your doorstep.</p>
          </div>
          <div className="module-card fade-in" onClick={() => document.getElementById('cp-service-support').scrollIntoView({ behavior: 'smooth' })}>
            <div className="module-icon">
              <img src="/images/cp/servicesupport.png" alt="Service Support" className="module-img" />
            </div>
            <h3>Service Support</h3>
            <p className="tagline">Breakdown? We've Got You.</p>
            <p>24/7 emergency roadside assistance powered by GPS technology.</p>
          </div>
          <div className="module-card fade-in" onClick={() => document.getElementById('cp-spares-fms').scrollIntoView({ behavior: 'smooth' })}>
            <div className="module-icon">
              <img src="/images/cp/sparesfms.png" alt="Spares & FMS" className="module-img" />
            </div>
            <h3>Spares & FMS</h3>
            <p className="tagline">Parts. Products. Performance.</p>
            <p>Find spare parts and manage your fleet with integrated solutions.</p>
          </div>
        </div>
      </section>

      {/* Module Details - Auctions */}
      <section className="module-detail" id="cp-auctions">
        <div className="module-detail-grid">
          <div className="module-detail-content fade-in">
            <div className="section-badge">MODULE 01</div>
            <h2>Auctions</h2>
            <p className="tagline">Bid. Win. Drive.</p>
            <p>Participate in LIVE auctions for a wide range of Commercial Vehicles and Construction Equipment from anywhere, anytime.</p>
            <ul className="feature-list">
              <li><strong>Live Bidding</strong><span>Real-time auction participation from your mobile</span></li>
              <li><strong>Pre-Approved Vehicles</strong><span>All auction vehicles are verified and documented</span></li>
              <li><strong>Wide Range</strong><span>Trucks, Tippers, Excavators, Loaders, Buses, and more</span></li>
              <li><strong>Transparent Process</strong><span>View vehicle history, inspection reports, and reserve prices</span></li>
              <li><strong>Instant Notifications</strong><span>Get alerts for upcoming auctions and bid status</span></li>
            </ul>
            <div className="target-audience">
              <strong>Target Audience:</strong>
              Fleet Owners | Dealers | Transporters | Construction Companies | Individual Buyers
            </div>
          </div>
          <div className="module-detail-image fade-in">
            <img src="/images/cp/auctions.png" alt="Auctions Module" className="detail-img" />
          </div>
        </div>
      </section>

      {/* Module Details - Buy & Sell */}
      <section className="module-detail" id="cp-buy-sell">
        <div className="module-detail-grid">
          <div className="module-detail-content fade-in">
            <div className="section-badge">MODULE 02</div>
            <h2>Buy & Sell</h2>
            <p className="tagline">List. Connect. Deal.</p>
            <p>The largest marketplace for used Commercial Vehicles and Construction Equipment.</p>
            <h4 style={{ color: 'var(--primary)', margin: '20px 0 10px' }}>For Sellers:</h4>
            <ul className="feature-list">
              <li><strong>Quick Listing</strong><span>List your used vehicles in minutes with photos & details</span></li>
              <li><strong>Pan-India Reach</strong><span>Reach thousands of verified buyers across India</span></li>
              <li><strong>In-App Inspection</strong><span>Request inspection to increase buyer confidence</span></li>
            </ul>
            <h4 style={{ color: 'var(--primary)', margin: '20px 0 10px' }}>For Buyers:</h4>
            <ul className="feature-list">
              <li><strong>Advanced Search</strong><span>Filter by make, model, year, price, location</span></li>
              <li><strong>Direct Connect</strong><span>Connect with sellers via chat/call</span></li>
              <li><strong>Pre-Purchase Inspection</strong><span>Request vehicle inspection before purchase</span></li>
            </ul>
            <div className="target-audience">
              <strong>Target Audience:</strong>
              Fleet Owners | Individual Sellers | Dealers | First-Time Buyers | Transporters | Individual Buyers
            </div>
          </div>
          <div className="module-detail-image fade-in">
            <img src="/images/cp/buysell.png" alt="Buy & Sell Module" className="detail-img" />
          </div>
        </div>
      </section>

      {/* Module Details - Insurance & Finance */}
      <section className="module-detail" id="cp-insurance-finance">
        <div className="module-detail-grid">
          <div className="module-detail-content fade-in">
            <div className="section-badge">MODULE 03</div>
            <h2>Insurance & Finance</h2>
            <p className="tagline">Protect. Fund. Grow.</p>
            <p>Get the best insurance coverage and financing options for your vehicles at attractive market rates.</p>
            <h4 style={{ color: 'var(--primary)', margin: '20px 0 10px' }}>Insurance Features:</h4>
            <ul className="feature-list">
              <li><strong>Comprehensive Coverage</strong><span>Comprehensive & Third-Party options available</span></li>
              <li><strong>Quick Claims</strong><span>Fast claim processing from top insurers</span></li>
              <li><strong>Instant Policy</strong><span>Generate policy instantly with renewal reminders</span></li>
            </ul>
            <h4 style={{ color: 'var(--primary)', margin: '20px 0 10px' }}>Finance Features:</h4>
            <ul className="feature-list">
              <li><strong>Partner Network</strong><span>Tie-ups with leading NBFCs & Banks</span></li>
              <li><strong>Quick Approval</strong><span>Minimal documentation, fast loan approval</span></li>
              <li><strong>Competitive Rates</strong><span>Best interest rates for new & used vehicles</span></li>
            </ul>
            <div className="target-audience">
              <strong>Target Audience:</strong>
              Vehicle Owners | Fleet Operators | New Buyers | Dealers | Transporters | Individual Buyers
            </div>
          </div>
          <div className="module-detail-image fade-in">
            <img src="/images/cp/insurancefinance.png" alt="Insurance & Finance Module" className="detail-img" />
          </div>
        </div>
      </section>

      {/* Module Details - Inspection */}
      <section className="module-detail" id="cp-inspection">
        <div className="module-detail-grid">
          <div className="module-detail-content fade-in">
            <div className="section-badge">MODULE 04</div>
            <h2>Inspection & Valuation</h2>
            <p className="tagline">Inspect. Evaluate. Decide.</p>
            <p>Get professional vehicle inspection and accurate valuation reports at your fingertips.</p>
            <div className="steps">
              <div className="step">
                <div className="step-number">1</div>
                <h4>Place Request</h4>
                <p>Submit request with vehicle details and preferred date/time</p>
              </div>
              <div className="step">
                <div className="step-number">2</div>
                <h4>Mechanic Visit</h4>
                <p>Certified mechanic conducts 150+ point inspection</p>
              </div>
              <div className="step">
                <div className="step-number">3</div>
                <h4>Get Report</h4>
                <p>Receive detailed report with photos and valuation</p>
              </div>
            </div>
            <h4 style={{ color: 'var(--primary)', margin: '20px 0 10px' }}>Inspection Covers:</h4>
            <p>Engine & Transmission | Body & Chassis | Electrical Systems | Tyre & Brake | Document Verification | Overall Condition Rating | Individual Buyers</p>
            <div className="target-audience">
              <strong>Perfect for:</strong>
              Buyers | Sellers | Banks | Insurance Companies
            </div>
          </div>
          <div className="module-detail-image fade-in">
            <img src="/images/cp/inspectionvaluation.png" alt="Inspection & Valuation Module" className="detail-img" />
          </div>
        </div>
      </section>

      {/* Module Details - Service Support */}
      <section className="module-detail" id="cp-service-support">
        <div className="module-detail-grid">
          <div className="module-detail-content fade-in">
            <div className="section-badge">MODULE 05</div>
            <h2>Service Support</h2>
            <p className="tagline">Breakdown? We've Got You Covered.</p>
            <p>24/7 emergency roadside assistance and service support powered by GPS technology.</p>
            <ul className="feature-list">
              <li><strong>GPS-Based Mechanic Locator</strong><span>Find mechanics and service centers near your current location instantly</span></li>
              <li><strong>Breakdown Assistance</strong><span>One-tap emergency support for breakdowns anywhere on the road</span></li>
              <li><strong>Mechanic Profiles</strong><span>View ratings, specializations, and contact details of nearby mechanics</span></li>
              <li><strong>Towing Services</strong><span>Request towing assistance directly from the app</span></li>
              {/* <li><strong>Service History</strong><span>Track all your service requests and history</span></li> */}
            </ul>
            <div className="target-audience">
              <strong>Target Audience:</strong>
              Truck Drivers | Fleet Operators | Long-Haul Transporters | Owner-Operators| Individual Buyers
            </div>
          </div>
          <div className="module-detail-image fade-in">
            <img src="/images/cp/servicesupport.png" alt="Service Support Module" className="detail-img" />
          </div>
        </div>
      </section>

      {/* Module Details - Spares & FMS */}
      <section className="module-detail" id="cp-spares-fms">
        <div className="module-detail-grid">
          <div className="module-detail-content fade-in">
            <div className="section-badge">MODULE 06</div>
            <h2>Spares & FMS</h2>
            <p className="tagline">Parts. Products. Performance.</p>
            <p>Find spare parts and manage your fleet efficiently with our integrated solutions.</p>
            <h4 style={{ color: 'var(--primary)', margin: '20px 0 10px' }}>Spares Features:</h4>
            <ul className="feature-list">
              <li><strong>GPS-Based Discovery</strong><span>Locate CV & CE spare parts shops near you</span></li>
              <li><strong>Shop Directory</strong><span>View shop details, contact info & directions</span></li>
              <li><strong>Wide Range</strong><span>Genuine & aftermarket parts available</span></li>
            </ul>
            <h4 style={{ color: 'var(--primary)', margin: '20px 0 10px' }}>Fleet Management Solutions (FMS):</h4>
            <ul className="feature-list">
              <li><strong>E-commerce Platform</strong><span>Exclusive spare parts with doorstep delivery</span></li>
              <li><strong>Bulk Ordering</strong><span>Special pricing for fleet operators</span></li>
              <li><strong>Product Categories</strong><span>Lubrication Solutions | GPS | Fleet Management | Diesel Theft Devices | Many more...</span></li>
            </ul>
            <div className="target-audience">
              <strong>Target Audience:</strong>
              Fleet Operators | Workshop Owners | Mechanics | Transporters | Logistics Companies
            </div>
          </div>
          <div className="module-detail-image fade-in">
            <img src="/images/cp/sparesfms.png" alt="Spares & FMS Module" className="detail-img" />
          </div>
        </div>
      </section>

      {/* Ecosystem Section */}
      <section className="ecosystem">
        <div className="section-header">
          <div className="section-badge">ECOSYSTEM</div>
          <h2 className="section-title">One App. <span>Complete Ecosystem.</span></h2>
          <p className="section-subtitle">VahaanBazar connects all stakeholders in the automobile industry</p>
        </div>
        <div className="ecosystem-diagram fade-in">
          <div className="ecosystem-center">
            <img src="https://vahaan-buy-and-sell-category-images.s3.ap-south-1.amazonaws.com/VahaanBazar_Image.png" alt="VahaanBazar Logo" className="ecosystem-logo" />
          </div>
          <div className="ecosystem-modules">
            <div className="eco-module"><i className="fas fa-gavel"></i> Auctions</div>
            <div className="eco-module"><i className="fas fa-exchange-alt"></i> Buy & Sell</div>
            <div className="eco-module"><i className="fas fa-shield-alt"></i> Insurance & Finance</div>
            <div className="eco-module"><i className="fas fa-search"></i> Inspection & Valuation</div>
            <div className="eco-module"><i className="fas fa-tools"></i> Service Support</div>
            <div className="eco-module"><i className="fas fa-cogs"></i> Spares & FMS</div>
          </div>
          <div className="stakeholders">
            <div className="stakeholder"><i className="fas fa-truck"></i> Fleet Owners</div>
            <div className="stakeholder"><i className="fas fa-store"></i> Dealers</div>
            <div className="stakeholder"><i className="fas fa-industry"></i> OEMs</div>
            <div className="stakeholder"><i className="fas fa-shipping-fast"></i> Transporters</div>
            <div className="stakeholder"><i className="fas fa-university"></i> Banks & NBFCs</div>
            <div className="stakeholder"><i className="fas fa-file-contract"></i> Insurance Companies</div>
            <div className="stakeholder"><i className="fas fa-wrench"></i> Mechanics</div>
            <div className="stakeholder"><i className="fas fa-user"></i> Individual Buyers</div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-us" id="cp-why-us" style={{
        background: `linear-gradient(rgba(255, 255, 255, 0.88), rgba(255, 255, 255, 0.88)), url('/images/cp/new_image.png') center/cover no-repeat fixed`
      }}>
        <div className="section-header">
          <div className="section-badge">WHY US</div>
          <h2 className="section-title">Why Choose <span>VahaanBazar</span></h2>
        </div>
        <div className="why-grid">
          <div className="why-card fade-in">
            <i className="fas fa-globe-asia"></i>
            <h3>Extensive Reach</h3>
            <p>Pan-India coverage with thousands of listings. Wide network of dealers, mechanics & service providers. Access to exclusive auction inventory.</p>
          </div>
          <div className="why-card fade-in">
            <i className="fas fa-handshake"></i>
            <h3>Trust & Transparency</h3>
            <p>Verified listings and pre-approved auction vehicles. Professional inspection reports. Secure transaction process.</p>
          </div>
          <div className="why-card fade-in">
            <i className="fas fa-mobile-alt"></i>
            <h3>Convenience</h3>
            <p>Everything in one app - buy, sell, auction, service. GPS-enabled features for instant assistance. 24/7 access from anywhere.</p>
          </div>
          <div className="why-card fade-in">
            <i className="fas fa-headset"></i>
            <h3>Expert Support</h3>
            <p>Dedicated customer support team. Professional mechanics for inspections. Finance & insurance advisory.</p>
          </div>
          <div className="why-card fade-in">
            <i className="fas fa-microchip"></i>
            <h3>Technology-Driven</h3>
            <p>Real-time auction bidding. GPS-based mechanic locator. Digital documentation & reports.</p>
          </div>
          <div className="why-card fade-in">
            <i className="fas fa-check-double"></i>
            <h3>Verified Listings</h3>
            <p>All vehicles and partners are verified. Pre-approved auction inventory. Quality assurance on every transaction.</p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="section-header">
          <div className="section-badge" style={{ background: 'rgba(255,255,255,0.2)', color: 'white' }}>FEATURES</div>
          <h2 className="section-title">Our Features</h2>
        </div>
        <div className="features-grid">
          <div className="feature-card fade-in">
            <i className="fas fa-eye"></i>
            <h4>Transparency</h4>
            <p>All dealings are open and verified</p>
          </div>
          <div className="feature-card fade-in">
            <i className="fas fa-star"></i>
            <h4>Best In Class Service</h4>
            <p>Professional & reliable support</p>
          </div>
          <div className="feature-card fade-in">
            <i className="fas fa-trophy"></i>
            <h4>Win-Win Approach</h4>
            <p>Value for both buyer & seller</p>
          </div>
          <div className="feature-card fade-in">
            <i className="fas fa-mobile-alt"></i>
            <h4>Mobile-First Platform</h4>
            <p>Access everything on the go</p>
          </div>
          <div className="feature-card fade-in">
            <i className="fas fa-map-marker-alt"></i>
            <h4>GPS-Enabled Services</h4>
            <p>Location-based instant support</p>
          </div>
          <div className="feature-card fade-in">
            <i className="fas fa-check-circle"></i>
            <h4>Verified Listings</h4>
            <p>Trusted vehicles & partners</p>
          </div>
        </div>
      </section>

      {/* B2B & B2C Section */}
      <section className="b2b-b2c">
        <div className="section-header">
          <div className="section-badge">FOR EVERYONE</div>
          <h2 className="section-title">For Businesses & <span>Individuals</span></h2>
        </div>
        <div className="audience-grid">
          <div className="audience-card fade-in">
            <div className="audience-header">
              <i className="fas fa-building"></i>
              <h3>For Business Partners</h3>
              <p>Grow Your Business with VahaanBazar</p>
            </div>
            <div className="audience-body">
              <div className="audience-item">
                <h4>Fleet Owners & Transporters</h4>
                <ul>
                  <li>List your fleet for sale or auction</li>
                  <li>Access finance & insurance at best rates</li>
                  <li>GPS-enabled breakdown support for drivers</li>
                </ul>
              </div>
              <div className="audience-item">
                <h4>Dealers</h4>
                <ul>
                  <li>Reach thousands of verified buyers</li>
                  <li>Participate in exclusive auctions</li>
                  <li>Inspection services for your inventory</li>
                </ul>
              </div>
              <div className="audience-item">
                <h4>Banks, NBFCs & Insurance</h4>
                <ul>
                  <li>Access to verified vehicle inventory</li>
                  <li>Professional valuation reports</li>
                  <li>Direct customer connect</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="audience-card fade-in">
            <div className="audience-header" style={{ background: 'var(--black)' }}>
              <i className="fas fa-user"></i>
              <h3>For Individual Users</h3>
              <p>Buy, Sell & Service Made Easy</p>
            </div>
            <div className="audience-body">
              <div className="audience-item">
                <h4>Buying a Vehicle?</h4>
                <ul>
                  <li>Browse thousands of verified listings</li>
                  <li>Participate in live auctions</li>
                  <li>Request inspection before you buy</li>
                  <li>Get finance approval in minutes</li>
                </ul>
              </div>
              <div className="audience-item">
                <h4>Selling Your Vehicle?</h4>
                <ul>
                  <li>List for free in minutes</li>
                  <li>Reach verified buyers pan-India</li>
                  <li>Get professional valuation</li>
                </ul>
              </div>
              <div className="audience-item">
                <h4>Need Service?</h4>
                <ul>
                  <li>Find mechanics near you instantly</li>
                  <li>24/7 breakdown assistance</li>
                  <li>Genuine spare parts at best prices</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Combined Footer */}
      <footer className="combined-footer" id="cp-contact">
        <div className="footer-main">
          <div className="footer-brand">
            <img src="https://vahaan-buy-and-sell-category-images.s3.ap-south-1.amazonaws.com/VahaanBazar_Image.png" alt="VahaanBazar Logo" className="footer-logo" />
            <p>India's Complete Used Automobile Marketplace</p>
            <div className="footer-app-badges">
              <a href="https://play.google.com/store/apps/details?id=com.vahaanbazar.app" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-google-play"></i> Google Play
              </a>
              <a href="https://apps.apple.com/in/app/vahaanbazar/id6753955870" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-apple"></i> App Store
              </a>
            </div>
            <div className="footer-social">
              <h4>Follow Us</h4>
              <div className="social-icons">
                <a href="#"><i className="fab fa-linkedin-in"></i></a>
                <a href="#"><i className="fab fa-instagram"></i></a>
                <a href="#"><i className="fab fa-facebook-f"></i></a>
                <a href="#"><i className="fab fa-twitter"></i></a>
                <a href="#"><i className="fab fa-youtube"></i></a>
              </div>
            </div>
          </div>
          <div className="footer-franchise-zone">
            <a href="/franchise" className="franchise-zone-link">
              <i className="fas fa-handshake"></i>
              <h4>Investor / Franchise Zone</h4>
              <p>Partner with India's fastest growing used vehicle marketplace</p>
              <span className="franchise-cta">Explore Opportunities <i className="fas fa-arrow-right"></i></span>
            </a>
          </div>
          <div className="footer-contact">
            <h4>Contact Us</h4>
            <p><i className="fas fa-envelope"></i> <a href="mailto:contactus@vahaanbazar.com">contactus@vahaanbazar.com</a></p>
            <p><i className="fas fa-phone-alt"></i> <a href="tel:+918886630455">+91 8886630455</a></p>
            <p><i className="fas fa-globe"></i> <a href="https://www.vahaanbazar.com" target="_blank" rel="noopener noreferrer">www.vahaanbazar.com</a></p>
            <p><i className="fas fa-map-marker-alt"></i> Hyderabad, India</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Vahaan Bazar Private Limited. All Rights Reserved.</p>
          <div className="footer-legal">
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-and-conditions">Terms of Service</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default CpPage;
